<template>
  <div>
    <div v-if="!hasGenerated">
      <div class="row">
        <div class="col-xs-12">
          <blockquote>
            Tariff Profile Overview
          </blockquote>
        </div>
        <div class="col-xs-12 col-md-8 mt-20">
          <div class="clearfix" v-if="visible">
            <div class="panel panel-default mai-panel">
              <div class="panel-heading"><i class="fa fa-bar-chart"></i> Countries used by this profile</div>
              <div class="panel-body clearfix" style="min-height: 380px;">
                <am-map :mapData="mapData"></am-map>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-4 mt-20">
          <div class="clearfix">
            <div class="panel panel-default mai-panel">
              <div class="panel-heading"><i class="fa fa-info"></i> Profile info</div>
              <div class="panel-body clearfix" style="min-height: 380px;">
                <info-widget
                  :stats="{ title: '# Potential Lookups', stat: lookups.length }"
                  backgroundColor="#00beee"
                  logo="fa fa-binoculars"
                  color="#fff"
                  animate
                  class="col-xs-12 mt-20">
                </info-widget>
                <info-widget
                  :stats="{ title: '# Locations Used', stat: locations.length }"
                  backgroundColor="#02a85c"
                  logo="fa fa-globe"
                  color="#fff"
                  animate
                  class="col-xs-12 mt-20">
                </info-widget>
                <info-widget
                  :stats="{ title: '# Potential Lines ', stat: cLines.length * lookups.length }"
                  backgroundColor="#f39c11"
                  logo="fa fa-industry"
                  color="#fff"
                  animate
                  class="col-xs-12 mt-20">
                </info-widget>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="clearfix">
            <div class="panel panel-default mai-panel">
              <div class="panel-heading"><i class="fa fa-info"></i> Details</div>
              <div class="panel-body clearfix" style="min-height: 380px;">

                <vue-table
                  :showDelete="false"
                  :showEdit="false"
                  :tableData="overviewTableData"
                  tableTitle="Details"
                  :fields="[
                    { prop: 'key', header: 'Item' },
                    { prop: 'val', header: 'Entry' }
                  ]"
                >
                </vue-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="hasGenerated">
      <div class="row">
        <div class="col-xs-12">
          <blockquote>
            Lookups
          </blockquote>
        </div>
      </div>
      <vue-table
        :showDelete="false"
        :showEdit="false"
        :tableData="generatedLookups"
        tableTitle="Lookups"
        :fields="headers"
        :hasSlot="true"
      >
        <div slot-scope="maiScope" slot="icons">
          <div :class="[maiScope.item.id ? 'sq wide' : '', 'btn btn-danger']" data-toggle="tooltip" title="Delete" @click="removeLookup({ item: maiScope.item, index: maiScope.index })">
            <i class="fa fa-trash"></i>
          </div>
          <div v-if="!maiScope.item.id" class="btn btn-success" data-toggle="tooltip" title="Save" @click="saveLookup(maiScope.item, maiScope.index)">
            <i class="fa fa-check"></i>
          </div>
          <parse-from-json
            v-if="maiScope.item.id"
            :disabled="false"
            :json="generateLines(maiScope.item)"
            :fileName="`lookup-${maiScope.item.id}-lines`"
          >
          </parse-from-json>
          <parse-to-json
            v-if="maiScope.item.id"
            v-on:parse-start="parsing"
            v-on:parse-complete="parsed"
            :showIcon="false"
          ></parse-to-json>
        </div>
        <!--
          <template slot="scoped-slot" scope="maiScope">
            <parse-from-json
              :disabled="false"
              :json="jsonify(maiScope.item)"
              fileName="rateassist"
            >
            </parse-from-json>
          </template>
        -->
      </vue-table>
    </div>
    <footer class="clearfix">
      <hr>
      <h5>
        If the above information looks correct, you can (re)generate and then subquently save new tariffs by clicking the regenerate button to the right;
        <strong>ALL PRIOR EXISTING TARIFFS FROM THIS PROFILE WILL BE DELETED</strong>
      </h5>
      <div class="pull-right">
        <div :class="[ details.id ? '' : 'disabled',  'btn btn-primary sq' ]" @click="generate">
          Regenerate
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
  import ParseFromJson from '../../helpers/ParseFromJson'
  import ParseToJson from '../../helpers/ParseToJson'
  import VueTable from '../../helpers/VueTable'
  import InfoWidget from '../../helpers/InfoWidget'
  import CalculatedFieldsMixin from '../../helpers/CalculatedFieldsMixin'
  import AmMap from '../../../components/charts/AmMap'
  import LookupHelperMixin from '../../admin/mixins/Helpers'
  import API from '../../../api/endpoints'
  import event from '../../../event'
  export default {
    name: 'Lookups',
    mixins: [LookupHelperMixin, CalculatedFieldsMixin],
    data () {
      return {
        json: [],
        generatedLookups: [],
        hasGenerated: false
      }
    },
    props: [ 'common', 'woodLoose', 'containerTypes', 'cartesianElements', 'cartesianHeaders', 'details', 'visible', 'tariffCode' ],
    components: {
      VueTable,
      ParseFromJson,
      ParseToJson,
      InfoWidget,
      AmMap
    },
    watch: {
      '$route' (newVal, oldVal) {
        this.hasGenerated = false
      }
    },
    computed: {
      lookupTypes () {
        return this.getSystemOptions('LOOKUP_TYPE')
      },
      woodLooses () {
        return this.getSystemOptions('WOOD_LOOSE')
      },
      containers () {
        return this.getSystemOptions('CONTAINER_TYPE')
      },
      distanceTypes () {
        return this.getSystemOptions('DISTANCE_TYPE')
      },
      overviewTableData () {
        let rows = [
          { key: 'Service Provider', val: this.details.serviceProvider ? this.details.serviceProvider.name : '' },
          { key: 'Tariff Profile Type', val: this.tariffProfile ? this.tariffProfile.name : '' },
          { key: 'Service Contract', val: this.details.serviceContract },
          { key: 'Description', val: this.details.description },
          { key: 'Notes', val: this.details.notes },
          { key: 'Effective From', val: this.details.effectiveFrom },
          { key: 'Effective To', val: this.details.effectiveTo },
          { key: 'Density', val: this.details.density },
          { key: 'Wood Loose', val: this.woodLooseValuesToString },
          { key: 'Container Types', val: this.containerValuesToString },
          { key: 'Origins', val: this.locationsToString('origin') },
          { key: 'Destinations', val: this.isTypePort ? this.locationsToString('origin') : this.locationsToString('destination') },
          { key: 'On Carriage', val: this.locationsToString('onCarriage') },
          { key: 'Pre Carriage', val: this.locationsToString('preCarriage') }
        ]
        return rows
      },
      tariffProfile () {
        return this.getSystemOption(this.details.lookupProfileType)
      },
      lookups () {
        return this.linesWithHeaders.map(line => {
          return {
            ...line,
            ...this.common
          }
        })
      },
      woodLooseValuesToString () {
        return this.details.woodLooseSelections.length === 0 ? ''
          : this.details.woodLooseSelections.reduce((value, element) => {
            if (value.length > 0) {
              value += ', '
            }
            value += element.dataOption
            return value
          }, '')
      },
      containerValuesToString () {
        return this.details.containerTypeSelections.length === 0 ? ''
          : this.details.containerTypeSelections.reduce((value, element) => {
            if (value.length > 0) {
              value += ', '
            }
            value += element.dataOption
            return value
          }, '')
      },
      locations () {
        let locationProps = [ 'origin', 'destination', 'onCarriage', 'preCarriage' ]
        let locations = []
        for (let prop in this.details) {
          if (locationProps.includes(prop)) {
            locations.push(...this.details[prop])
          }
        }
        return locations
      },
      linesWithHeaders () {
        return this.lines.map(line => {
          return {
            woodLoose: line[0],
            containerType: line[1]
          }
        })
      },
      lines () {
        return this.doCartesian(this.woodLooseOrNull, this.containersOrNull)
      },
      mapData () {
        let data = []
        this.locations.forEach(({location}) => {
          if (location !== null && location.country !== null) {
            const { code, name } = location.country
            let addNew = true
            data.forEach(country => {
              if (country.code === code) {
                addNew = false
                country.value++
              }
            })
            if (addNew) {
              data.push({ code, name, value: 1 })
            }
          }
        })
        return data
      },
      woodLooseOrNull () {
        return this.woodLoose.length > 0 ? this.woodLoose : [null]
      },
      containersOrNull () {
        return this.containerTypes.length > 0 ? this.containerTypes : [null]
      },
      headers () {
        let headers = [
          {
            prop: item => item.uploaded ? 'Y' : 'N',
            header: 'Upload'
          },
          {
            prop: 'id',
            header: 'ID',
            numericalField: true
          },
          {
            prop: 'name',
            header: 'Name'
          },
          {
            header: 'Container Type',
            prop: 'containerType'
          },
          {
            header: 'Wood Loose',
            prop: 'woodLoose'
          },
          {
            header: 'Service Provider',
            prop: this.details.serviceProvider.name
          }
        ]
        return headers
      },
      cLinesWithHeaders () {
        let lines = []
        this.cLines.forEach(line => {
          let obj = {}
          for (let i = 0; i < line.length; i++) {
            let val = line[i]
            if (typeof val === 'object' && val !== null) {
              for (let prop in val) {
                obj[prop] = val[prop]
              }
            } else if (typeof val === 'object' && val === null) {
              continue
            } else {
              obj[this.cartesianHeaders[i]] = line[i]
            }
          }
          lines.push(obj)
        })
        return lines
      },
      cLines () {
        const results = this.doCartesian(...this.cartesianElements)
        return this.postProcessCLines(results)
      },
      canRegenerate () {
        return JSON.stringify(this.lookups) !== JSON.stringify(this.generatedLookups)
      },
      accessorials () {
        return this.details.hasOwnProperty('accessorials') ? this.details.accessorials : []
      },
      isTypePort () {
        return this.tariffCode === 'POR'
      }
    },
    methods: {
      getOptionId (thisProp, findName) {
        let opt = this[thisProp].find(({name}) => name === findName)
        return opt ? opt.id : null
      },
      removeLookup ({item, index}) {
        if (item.id !== null && item.id > 0) {
          event.$emit('loading-on', { title: 'Saving Lookup' })
          this.$http.delete(API.DELETE_ADMIN_ENTITY('lookup', item.id))
          .then(res => {
            this.generatedLookups.splice(index, 1)
            event.$emit('toast', { type: 'success', message: 'Lookup deleted' })
          }).catch(err => {
            event.$emit('toast', { type: 'warning', message: 'Unable to Delete Lookup' })
            console.log(err)
          }).then(() => {
            event.$emit('loading-off')
          })
        } else {
          this.generatedLookups.splice(index, 1)
        }
      },
      saveLookup (item, index) {
        event.$emit('loading-on', { title: 'Saving Lookup' })
        let woodLoose = this.getOptionId('woodLooses', item.woodLoose)
        let containerType = this.getOptionId('containers', item.containerType)
        // let distanceType = this.getOptionId('distanceTypes', item.distanceType)
        // console.log()
        this.$http.post(API.CREATE_ADMIN_ENTITY('lookup'), { ...item, suspended: true, woodLoose, containerType })
        .then(({data}) => {
          if (data.hasOwnProperty('id')) {
            this.generatedLookups[index].id = data.id
            this.relateAccessorialsToLookup(data.id)
            event.$emit('toast', { type: 'success', message: 'Lookup Saved' })
          } else {
            event.$emit('toast', { type: 'warning', message: 'Unable to Save Lookup' })
          }
        }).catch(err => {
          event.$emit('toast', { type: 'warning', message: 'Unable to Save Lookup' })
          console.log(err)
        }).then(() => {
          event.$emit('loading-off')
        })
      },
      relateAccessorialsToLookup (lookup) {
        let accessorials = this.accessorials.map(obj => {
          return { ...obj, lookup, id: null, lookupProfile: null }
        })
        if (accessorials.length > 0) {
          event.$emit('loading-on', {})
          this.$http.post(API.BATCH_CREATE_ADMIN_ENTITY('lookup-addition'), accessorials)
          .then(() => {
            event.$emit('toast', { type: 'success', message: 'All accessorials added to tariff successfully uploaded' })
          }).catch(err => {
            console.log(err)
            event.$emit('toast', { type: 'warning', message: 'An error occured while trying to upload accessorials' })
          }).then(() => {
            event.$emit('loading-off')
          })
        }
        if (this.details.notes != null && this.details.notes.length > 0) {
          this.attachNote(lookup)
        }
      },
      attachNote (lookup) {
        this.$http.post(API.CREATE_ADMIN_ENTITY('note'), { noteText: this.details.notes, title: 'GENERATED', category: 'LOOKUP', lookup })
        .then(() => {
          event.$emit('toast', { type: 'success', message: 'Note attached to tariff' })
        }).catch(err => {
          console.log(err)
          event.$emit('toast', { type: 'warning', message: 'An error occured while trying to attach a note to the tariff' })
        })
      },
      locationsToString (prop) {
        return this.details[prop].length === 0 ? ''
          : this.details[prop].reduce((value, element) => {
            if (value.length > 0) {
              value += ', '
            }
            value += element.location.name
            return value
          }, '')
      },
      generateLines (item) {
        let lines = []
        this.cLinesWithHeaders.forEach(obj => {
          let line = {}
          line.lookup = item.id
          line.containerType = item.containerType
          line.woodLoose = item.woodLoose
          lines.push({
            ...line,
            ...obj,
            lineRate: null,
            onCarriageRate: null,
            preCarriageRate: null,
            isMinimum: null,
            minimum: null,
            transitTime: null,
            maximumCharge: null
          })
        })
        return lines
      },
      generate () {
        if (this.details.id) {
          let lookups = []
          this.lookups.forEach((obj, index) => {
            let lookup = {}
            let str = this.generateLookupName(obj, index + 1)
            let lookupType = this.reverseLookupType(obj)
            lookup.id = null
            lookup.name = str
            lookup.code = this.details.serviceProvider.code
            lookup.description = str
            lookup.lookupType = lookupType
            lookup.breakpointPer = obj.breakpointsPer
            lookup.ratesPer = obj.ratesPer
            lookup.distanceType = obj.distanceType
            lookup.effectiveTo = obj.effectiveTo
            lookup.effectiveFrom = obj.effectiveFrom
            lookup.minimumDensityType = obj.densityType
            lookup.mode = obj.mode
            lookup.lookupProfile = obj.id
            lookup.minimumDensity = obj.density
            lookup.owner = parseInt(this.details.serviceProvider.id)
            lookup.containerType = obj.containerType
            lookup.woodLoose = obj.woodLoose
            lookup.serviceClass = obj.serviceClass
            lookup.lookupCurrency = this.details.serviceProvider && this.details.serviceProvider.paymentCurrency
            // lookup.onCarriageCurrency = this.details.serviceProvider && this.details.serviceProvider.paymentCurrency
            // lookup.preCarriageCurrency = this.details.serviceProvider && this.details.serviceProvider.paymentCurrency
            lookups.push(lookup)
          })
          event.$emit('loading-on', { title: 'Removing prior Lookups' })
          this.doPriorLookupDelete().then(res => {
            this.generatedLookups = lookups
            this.hasGenerated = true
            event.$emit('toast', { type: 'success', message: 'All Lookups attached to this Profile deleted' })
          }).catch(err => {
            event.$emit('toast', { type: 'warning', message: 'Unable to delete all prior Lookups' })
            console.log(err)
          }).then(() => {
            event.$emit('loading-off')
          })
        } else {
          event.$emit('toast', { type: 'warning', message: 'You must save the profile before continuing' })
        }
      },
      doPriorLookupDelete () {
        return new Promise((resolve, reject) => {
          if (this.details.id !== null && this.details.id > 0) {
            this.$http.get(API.GET_ENTITIES('lookup'), { params: { lookupProfile: this.details.id || 0 } })
            .then(({data}) => {
              if (data.length > 0) {
                let count = 0
                data.forEach(({id}) => {
                  this.$http.delete(API.DELETE_ADMIN_ENTITY('lookup', id))
                  .then(res => {
                    count++
                    if (count === data.length) {
                      resolve()
                    }
                  }).catch(err => reject(err))
                })
              } else {
                resolve()
              }
            }).catch(err => {
              console.log(err)
              reject()
            })
          } else {
            reject()
          }
        })
      },
      getMode (id) {
        let opt = this.getSystemOption(id)
        return opt ? opt.name : ''
      },
      generateLookupName (o, n) {
        return `${o.serviceProvider} ${String(o.id).padStart(6, '0')} ${n}${this.getLookupNameAddition(o)}`
      },
      getLookupNameAddition ({containerType, woodLoose, mode}) {
        let str = ''
        if (containerType) {
          str += ` ${containerType}`
        }
        if (woodLoose) {
          str += ` ${woodLoose}`
        }
        if (mode) {
          str += ` ${this.getMode(mode)}`
        }
        if (str === '') {
          str += ` ${this.details.serviceContract}`
        }
        return str
      },
      reverseLookupType ({lookupProfileType}) {
        let { code, valueAlpha } = this.getSystemOption(lookupProfileType)
        if (!valueAlpha) {
          return this.getReverseLookupByCode(code)
        } else {
          return this.getReverseLookupByAlpha(valueAlpha)
        }
      },
      getReverseLookupByCode (code) {
        if (code.indexOf('_') > -1) {
          code = code.substr(0, code.indexOf('_'))
        }
        let lookupType = this.lookupTypes.find(opt => {
          return opt.code === code
        })
        return lookupType ? lookupType.id : null
      },
      getReverseLookupByAlpha (alpha) {
        let lookupType = this.lookupTypes.find(opt => {
          return opt.code === alpha
        })
        return lookupType ? lookupType.id : null
      },
      doCartesian (a, b, ...c) {
        const f = (a, b) => [].concat(...a.map(d => b.map(e => [].concat(d, e))))
        if (b) {
          return this.doCartesian(f(a, b), ...c)
        } else if (a) {
          return a
        } else {
          return []
        }
      },
      jsonify (item) {
        return this.cLinesWithHeaders.map(obj => {
          return {
            ...obj,
            ...item
          }
        })
      },
      updateUploadField (tId) {
        let tariff = this.generatedLookups.find(({id}) => parseInt(id) === parseInt(tId))
        if (tariff) {
          this.$set(tariff, 'uploaded', true)
        }
      },
      parsing () {
        event.$emit('loading-on', { title: 'Parsing uploads' })
      },
      parsed ({data}) {
        event.$emit('loading-on', { title: 'Uploading lines' })
        let count = 0
        data.forEach(lookupDetail => {
          this.$http.post(API.SAVE_LOOKUP_DETAIL, lookupDetail)
          .then(res => {
            count++
            this.updateUploadField(lookupDetail.lookup)
            if (count === data.length) {
              event.$emit('loading-off')
              this.doCalculations(lookupDetail.lookup)
              .then(res => {
                event.$emit('toast', { type: 'success', message: 'Lines uploaded' })
              }).catch(err => {
                console.log(err)
                event.$emit('toast', { type: 'error', message: 'Unable to update calculated line values; please try again or contact support' })
              })
            }
          }).catch(err => {
            event.$emit('loading-off')
            event.$emit('toast', { type: 'warning', message: 'Some lines were unable to be uploaded; ' + err.message })
          })
        })
      },
      postProcessCLines (lines) {
        if (this.isTypePort) {
          lines.forEach(line => {
            if (line) {
              const origLocObject = line.filter(c => c.originTown)
              if (origLocObject) {
                let destLocObject = {}
                if (origLocObject[0].originTown) {
                  destLocObject.destinationTown = origLocObject[0].originTown
                }
                if (origLocObject[0].originState) {
                  destLocObject.destinationState = origLocObject[0].originState
                }
                if (origLocObject[0].originCountry) {
                  destLocObject.destinationCountry = origLocObject[0].originCountry
                }
                const origLocIndex = line.indexOf(origLocObject[0])
                line.splice(parseInt(origLocIndex + 1), 0, destLocObject)
              }
            }
          })
        }
        return lines
      }
    }
  }
</script>
<style>
.mt-20 {
  margin-top: 20px;
}
.btn.wide {
  width: 75px;
}
</style>



// WEBPACK FOOTER //
// Lookups.vue?ba8229ce